function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 之前使用的1.3.7版本的getAuthorization回调函数参数中无法获取到Key，已升级到1.5.0
import COS from 'cos-js-sdk-v5';
import { HTTPClient } from '@weike/toolkit';
import { getImageFileInfo, materialKeyMap, officeLiveroomId } from '../helpers'; // 腾讯云 cos 上传全球加速的固定域名

var DOMAIN = "{Bucket}.cos.accelerate.myqcloud.com";
export var WKCOS = /*#__PURE__*/function () {
  // cos鉴权的URL
  // cos鉴权的Key
  function WKCOS(baseURL, options) {
    if (options === void 0) {
      options = {};
    }

    this.baseURL = baseURL;

    _defineProperty(this, "cos", void 0);

    _defineProperty(this, "http", void 0);

    _defineProperty(this, "taskId", void 0);

    _defineProperty(this, "authorizeURL", void 0);

    _defineProperty(this, "authorizeKey", void 0);

    this.http = this.createHTTPClient(this.baseURL);
    this.cos = new COS(_extends({
      getAuthorization: this.cosAuthorization.bind(this),
      Domain: DOMAIN
    }, options));
  }
  /**
   * 传入baseURL
   *
   * @private
   * @param {string} baseURL
   * @returns
   * @memberof WK_COS
   */


  var _proto = WKCOS.prototype;

  _proto.createHTTPClient = function createHTTPClient(baseURL) {
    return new HTTPClient({
      baseURL: baseURL
    }, '0000');
  }
  /**
   * cos 的认证请求，每次上次 腾讯 cos sdk 都会自动调用，获取上传临时凭证
   *
   * @private
   * @param {GetAuthorizationOption} options
   * @param {GetAuthorizationCallback} callback
   * @memberof WK_COS
   */
  ;

  _proto.cosAuthorization = function cosAuthorization(options, callback) {
    this.http.get(this.authorizeURL, {
      params: {
        key: this.authorizeKey || options.Key,
        // sliceUploadFile方法首个块拿不到options.Key
        bucket: options.Bucket // 如果不传bucket时会生成临时桶的签名

      }
    }).then(function (res) {
      var data = res.data;
      var credentials = data && data.credentials;

      if (!data || !credentials) {
        return console.log('credentials invalid');
      }

      callback({
        TmpSecretId: credentials.tmpSecretId,
        TmpSecretKey: credentials.tmpSecretKey,
        XCosSecurityToken: credentials.sessionToken,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: data.startTime,
        // 时间戳，单位秒，如：1580000000
        ExpiredTime: data.expiredTime,
        // 时间戳，单位秒，如：1580000900
        ScopeLimit: true
      });
    });
  }
  /**
   * 文件上传
   *
   * @param {File} file 上传的文件
   * @param {SliceUploadFileParams} [options={}]
   * @param {ProgressHandler} [onProgress=() => {}] 进度回调
   * @returns {Promise<UploadResult>}
   * @memberof WK_COS
   */
  ;

  _proto.upload =
  /*#__PURE__*/
  function () {
    var _upload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
      var _this = this;

      var file, type, _ref$options, options, _ref$onProgress, onProgress, _ref$providerOptions, cosOptions, materialGroupId, isMaterialApi, params, apiPreUrl, res, msg, _msg, _res$data, url, key, bucket, region, media_sn;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file, type = _ref.type, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, _ref$onProgress = _ref.onProgress, onProgress = _ref$onProgress === void 0 ? function () {} : _ref$onProgress, _ref$providerOptions = _ref.providerOptions, cosOptions = _ref$providerOptions === void 0 ? {} : _ref$providerOptions, materialGroupId = _ref.materialGroupId, isMaterialApi = _ref.isMaterialApi;
              _context2.prev = 1;
              isMaterialApi = typeof isMaterialApi === 'boolean' ? isMaterialApi : false;
              options.is_temp_link = typeof options.is_temp_link === 'boolean' ? options.is_temp_link : true;
              this.authorizeURL = "/v1/integration" + (isMaterialApi ? '/wk_material/material.upload.credential.get' : '/wk_media_manager/outer/media_resource.upload.credential.get');
              options.liveroom_id = options.liveroom_id || officeLiveroomId;
              params = _extends({}, options, {
                source_sys_name: options.source_sys_name || 'wk_material',
                extend: options.extend || {
                  is_transcode: true,
                  resolutions: [],
                  object_list: [{
                    object_type: 'liveroom',
                    object_id: options.liveroom_id
                  }]
                }
              });

              if (file instanceof File) {
                params.filename = file.name;
              }

              apiPreUrl = "/v1/integration" + (isMaterialApi ? '/wk_material/material.upload.presigned.get' : '/wk_media_manager/outer/media_resource.upload.presigned.get');
              _context2.next = 11;
              return this.http.post(apiPreUrl, params).catch(function (err) {
                return _extends({}, err.data, {
                  isError: true
                });
              });

            case 11:
              res = _context2.sent;

              if (!res.isError) {
                _context2.next = 15;
                break;
              }

              console.error('presigned fail:', res); // 超容等情况对外提示

              return _context2.abrupt("return", Promise.reject({
                error: res,
                isError: true
              }));

            case 15:
              if (!(materialGroupId && !params.liveroom_id)) {
                _context2.next = 19;
                break;
              }

              msg = '指定分组下必须要有对应的直播间id';
              console.error('upload fail:', msg);
              return _context2.abrupt("return", Promise.reject({
                error: msg,
                isError: true
              }));

            case 19:
              if (!(isMaterialApi && !params.liveroom_id)) {
                _context2.next = 23;
                break;
              }

              _msg = '使用素材api上传时，必须要有直播间id';
              console.error('isMaterialApi为true时必传直播间id（素材超容校验），upload fail:', _msg);
              return _context2.abrupt("return", Promise.reject({
                error: _msg,
                isError: true
              }));

            case 23:
              _res$data = res.data, url = _res$data.file_url, key = _res$data.key, bucket = _res$data.bucket, region = _res$data.region, media_sn = _res$data.media_sn;
              this.authorizeKey = key;
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                _this.cos.sliceUploadFile(_extends({
                  Bucket: bucket,
                  Region: region,
                  Key: key,
                  Body: file,
                  // 分块阈值，超10M使用分块，（注：cos限制单个分块不超过5G）
                  SliceSize: 1024 * 1024 * 10,
                  onProgress: onProgress,
                  onTaskReady: function onTaskReady(TaskId) {
                    _this.taskId = TaskId;
                  }
                }, cosOptions), /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(error, data) {
                    var group_id, resource_type, content;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!error) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return", reject({
                              file: file,
                              error: error,
                              isError: true
                            }));

                          case 2:
                            // 默认进入直播间未分组（需要后台优化：添加素材接口不传分组id时直接进入未分组）
                            group_id = materialGroupId || 0; // if(!group_id) {
                            //   group_id = await this.http.post<IMcGroupRes>('/v1/integration/wk_material/material.group.list_get', {
                            //     liveroom_id: params.liveroom_id,
                            //     need_count: false,
                            //     only_can_update: false
                            //   } as IMcGroupReq).then(res=>{
                            //     const ungrouped = findItemByGroup(res.data.data_list, 'ungrouped')
                            //     return ungrouped && ungrouped.id
                            //   }).catch(console.error)
                            // }

                            if (!(group_id || group_id === 0)) {
                              _context.next = 14;
                              break;
                            }

                            // 添加到素材中心
                            resource_type = type || 'image'; // params.state.resource_type

                            content = {
                              size: file.size
                            };

                            if (!(resource_type === 'image')) {
                              _context.next = 10;
                              break;
                            }

                            _context.next = 9;
                            return getImageFileInfo(file).catch(function (err) {
                              return err;
                            });

                          case 9:
                            content = _context.sent;

                          case 10:
                            if (/video|audio/.test(resource_type)) {
                              content = _extends({}, content, {
                                duration: 0
                              });
                            }

                            _this.http.post('/v1/integration/wk_material/material.add', {
                              group_id: group_id,
                              liveroom_id: params.liveroom_id,
                              name: file instanceof File ? file.name : url.split('/').pop(),
                              mtype: materialKeyMap[resource_type],
                              url: url,
                              size: file.size,
                              media_sn: media_sn,
                              content: content
                            }).then(function (res) {
                              resolve({
                                file: file,
                                url: url,
                                data: data,
                                media_sn: media_sn,
                                material: res.data // 素材数据

                              });
                            }).catch(function (error) {
                              console.error('add material fail:', error);
                              resolve({
                                file: file,
                                url: url,
                                data: data,
                                media_sn: media_sn
                              }); // reject({error: error.data, file, isError: true})
                            });

                            _context.next = 15;
                            break;

                          case 14:
                            resolve({
                              file: file,
                              url: url,
                              data: data,
                              media_sn: media_sn
                            });

                          case 15:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              }));

            case 28:
              _context2.prev = 28;
              _context2.t0 = _context2["catch"](1);
              console.error('upload error:', _context2.t0);
              return _context2.abrupt("return", Promise.reject({
                error: _context2.t0,
                isError: true
              }));

            case 32:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 28]]);
    }));

    function upload(_x) {
      return _upload.apply(this, arguments);
    }

    return upload;
  }();

  _proto.cancel = /*#__PURE__*/function () {
    var _cancel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.cos.cancelTask(this.taskId);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function cancel() {
      return _cancel.apply(this, arguments);
    }

    return cancel;
  }();

  return WKCOS;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@weike/uploader/lib/esm/cos/cos.js
// module id = 642
// module chunks = 4